import React from 'react';
import { useTranslation } from 'react-i18next';
import galleryData from '../../data/home1/projects/projects1.json'; 

function Projects() {
  const { t } = useTranslation('homepage');

  return (
    <section className="tc-projects-style1">
      <div className="container">
        <div className="title mb-70 text-center">
          <h2 className="fsz-45"> {t('projects.title')} </h2>
        </div>

        <div className="tabs-links mb-50">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-gallery1-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-gallery1"
                    type="button"
                  >
                    {t('projects.tabs.exterior')}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-gallery2-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-gallery2"
                    type="button"
                  >
                    {t('projects.tabs.interior')}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="pills-gallery3-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-gallery3"
                    type="button"
                  >
                    {t('projects.tabs.garden')}
                  </button>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 mt-4 mt-lg-0 text-lg-end">
              <a
                href="/innerpages/gallery"
                className="butn border rounded-pill"
                style={{
                  borderColor: 'var(--color-primary)',
                  color: 'var(--color-primary)',
                }}
              >
                <span>
                  {t('projects.viewAllButton')}
                  <i className="small ms-1 ti-arrow-top-right"></i>
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="projects">
          <div className="tab-content" id="pills-tabContent">
            {/* Exterior Tab */}
            <div
              className="tab-pane fade show active"
              id="pills-gallery1"
              role="tabpanel"
              aria-labelledby="pills-gallery1-tab"
            >
              <GallerySlider items={galleryData.exterior} category="exterior" />
            </div>

            {/* Interior Tab */}
            <div
              className="tab-pane fade"
              id="pills-gallery2"
              role="tabpanel"
              aria-labelledby="pills-gallery2-tab"
            >
              <GallerySlider items={galleryData.interior} category="interior" />
            </div>

            {/* Garden Tab */}
            <div
              className="tab-pane fade"
              id="pills-gallery3"
              role="tabpanel"
              aria-labelledby="pills-gallery3-tab"
            >
              <GallerySlider items={galleryData.garden} category="garden" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function GallerySlider({ items, category }) {
  const { t } = useTranslation('homepage');
  const translatedItems = t(`gallery.${category}`, { returnObjects: true });

  return (
    <div className="projects-content float_box_container">
      <div className="projects-slider">
        <div className="swiper-wrapper">
          {items.map((item, i) => {
            const translatedItem = translatedItems[i] || {};
            return (
              <div key={i} className="swiper-slide">
                <div className="project-card">
                  <a href={item.img} className="img" data-fancybox="gallery">
                    <img src={item.img} alt={translatedItem.title || item.title} className="img-cover" />
                  </a>
                  <div className="info">
                    <h3 className="title">
                      <a href="#">{translatedItem.title || item.title}</a>
                    </h3>
                    <div className="text">{translatedItem.desc || item.desc}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="float-cursor float_box">
        {t('projects.dragText')}
      </div>
    </div>
  );
}

export default Projects;
